import { useClientSide } from '@carvana/merch-react-hooks';
import { useIsFromCreditKarma } from '~/context/vdp/StaticContext';

export default function useShowPriceDetailsImmediately() {
  const isFromCreditKarma = useIsFromCreditKarma();

  if (!useClientSide()) return false;

  const params = new URL(window.location.href.toLowerCase()).searchParams;
  const isFinanceActivationUser =
    params.has('oneusetoken') &&
    (params.has('isfinsearch') || params.get('actmodal') === 'finance');

  return isFromCreditKarma || isFinanceActivationUser;
}
